import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularArrowStepOut: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_arrow-step-out"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="arrow-step-out icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M14 16.5C14.4142 16.5 14.75 16.1642 14.75 15.75V4.62192L18.7075 8.76786C18.9935 9.06748 19.4682 9.07852 19.7679 8.79252C20.0675 8.50651 20.0785 8.03177 19.7925 7.73214L14.5425 2.23214C14.401 2.08388 14.205 2 14 2C13.795 2 13.599 2.08388 13.4575 2.23214L8.20748 7.73214C7.92148 8.03177 7.93252 8.50651 8.23214 8.79252C8.53177 9.07852 9.00651 9.06748 9.29252 8.76786L13.25 4.62192V15.75C13.25 16.1642 13.5858 16.5 14 16.5ZM18 22C18 24.2091 16.2091 26 14 26C11.7909 26 10 24.2091 10 22C10 19.7909 11.7909 18 14 18C16.2091 18 18 19.7909 18 22ZM16.5 22C16.5 20.6193 15.3807 19.5 14 19.5C12.6193 19.5 11.5 20.6193 11.5 22C11.5 23.3807 12.6193 24.5 14 24.5C15.3807 24.5 16.5 23.3807 16.5 22Z" />
      </svg>
    </span>
  );
};

export { RegularArrowStepOut };
